<template>
  <b-row>
    <b-col md="12">
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <el-table
          ref="griglia"
          :data="tableData"
          border
          height="300"
          style="width:100%;max-height:300px;min-height:300px;"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
          <el-table-column
            :min-width="80"
            prop="geometriaDescrizione"
            :label="uniTranslation('S572')"
            sortable
          />
          <el-table-column
            :min-width="90"
            prop="numeroDiPiastre"
            :label="uniTranslation('TRNSL253')"
            sortable
          >
            <template slot-scope="scope">{{ GetPiastre(scope.row) }}</template>
          </el-table-column>
          <el-table-column
            :min-width="150"
            prop="delta"
            :label="uniTranslation('TRNSL236')"
            sortable
          >
            <template slot-scope="scope">{{ parseFloat(scope.row.delta).toFixed(2) }}</template>
          </el-table-column>

          <!--
            <el-table-column prop="priceIndex" :label="'###Price Index'" sortable>
            <template slot-scope="scope">
              {{ parseFloat(scope.row.priceIndex).toFixed(0) }}
            </template>
          </el-table-column>
          -->
          <el-table-column
            :min-width="150"
            prop="potenza"
            :label="uniTranslation('Q1189') + ' [' + misureData['umPotenza'] + ']'"
            sortable
          >
            <template slot-scope="scope">{{ parseFloat(scope.row.potenza).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column
            :min-width="125"
            prop="portataPrimario"
            :label="uniTranslation('TRNSL254') + ' [' + misureData['umPortataPrimario'] + ']'"
            sortable
          >
            <template slot-scope="scope">{{
              parseFloat(scope.row.portataPrimario).toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column
            :min-width="125"
            prop="portataSecondario"
            :label="uniTranslation('TRNSL255') + ' [' + misureData['umPortataSecondario'] + ']'"
            sortable
          >
            <template slot-scope="scope">{{
              parseFloat(scope.row.portataSecondario).toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column
            prop="perditeDiCaricoTotaliPrimario"
            :label="'P Pd' + ' [' + misureData['umPerditeDiCaricoTotaliPrimario'] + ']'"
            sortable
          >
            <template slot-scope="scope">
              {{ parseFloat(scope.row.perditeDiCaricoTotaliPrimario).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="perditeDiCaricoTotaliSecondario"
            :label="'S Pd' + ' [' + misureData['umPerditeDiCaricoTotaliSecondario'] + ']'"
            sortable
          >
            <template slot-scope="scope">
              {{ parseFloat(scope.row.perditeDiCaricoTotaliSecondario).toFixed(2) }}
            </template>
          </el-table-column>
          
            <el-table-column v-if="isAdmin || isUnilab" prop="prezzo" :label="'prezzo'" sortable>
              <template slot-scope="scope">
                {{ parseFloat(scope.row.prezzo).toFixed(2) }}
              </template>
            </el-table-column>
          
          <el-table-column :min-width="55" label="" align="center">
            <template slot-scope="scope">
              <b-spinner v-show="scope.row.id == idLoad" label="Spinning"></b-spinner>
              <el-button
                v-show="scope.row.id == idVerifica"
                size="sm"
                class="fa fa-folder-open"
                @click="dblClick(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Table, TableColumn, Button } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";
//import projectService from "../../services/backend/projectService";

export default {
  components: {
    "el-table": Table,
    "el-table-column": TableColumn,
    "el-button": Button
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      idLoad: -1,
      bStoPopolando: false,
      idVerifica: -1,
      cacheData: [],
      resultData: [],
      tableData: [],
      misureData: {
        umPerditeDiCaricoTotaliPrimario: "",
        umPerditeDiCaricoTotaliSecondario: "",
        umPotenza: "",
        umPortataPrimario: "",
        umPortataSecondario: ""
      },
      currentRow: null,
      dblClickRow: null,
      defaultSort: null,
      unsubscribes: [] /*,
      modalitaExpert: false */
    };
  },

  computed: {
    ...mapGetters(["userLevel", "modalitaExpert"]),
    ...mapGetters("_colorsModule", ["cardColors"]),
    ...mapGetters("_prjModule", ["projects", "selectionOutput", "selectionResults"]),
    ...mapGetters("_authModule", [
      "isUserLogged",
      "loggedUserInfo",
      "isAdmin",
      "isDebug",
      "isUnilab"
    ])
  },

  created: function() {
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }
  },

  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },

  mounted() {
    var that = this;
    that.setColors();

    //this.popolaGriglia();

    /*
    that.$store.subscribe(function(mutation / *, state* /) {
      if (mutation.type === "refreshAll") {
        console.log("dopo refresh all");
        that.updateSelectionOutput();
      }
    });
    */

    //that.updateSort(that.modalitaExpert);
    that.unsubscribes.push(
      that.$store.subscribe(function(mutation) {
        if (mutation.type === "changeUserLevel") {
          let modalitaExpert = mutation.payload < 2;
          let sort = { prop: "delta", order: "ascending" };
          that.$refs.griglia.clearSort();
          that.$refs.griglia.sort(sort.prop, sort.order);
        }
      })
    );
  },
  watch: {
    cardColors() {
      this.setColors();
    }
  },
  methods: {
    ...mapActions("_prjModule", [
      "load",
      "save",
      "changeProperty",
      "impostaScambSelezionato",
      "setSelectionResults"
    ]),
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important";
      that.coloreTesto = that.cardColors[2];
      that.coloreBordo = that.cardColors[9];
    },
    GetPiastre(row) {
      var selP = this.resultData[row.id];

      var perc = selP.percentualeAltaResa;
      var piastre = selP.numeroPiastre;

      var res = "";

      if (perc > 0) {
        var high = Math.round((piastre * perc) / 100);
        var low = piastre - high;

        res = piastre + " ( H" + high + " + L" + low + " )";
      } else {
        res = piastre;
      }

      return res;
    },
    popolaGriglia() {
      var that = this;
      this.bStoPopolando = true;
      this.idLoad = -1;
      this.idVerifica = -1;
      this.cacheData = [];

      this.tableData = this.selectionOutput.selectionOutput; //jsonHelper.getProperty(this.projects, this.path + ".selectionOutput");
      this.misureData = this.selectionOutput.misureOutput; //jsonHelper.getProperty(this.projects, this.path + ".misureOutput");
      this.resultData = this.projects[this.parentPath].results; //jsonHelper.getProperty(this.projects, this.parentPath + ".results");

      //that.idLoad = -1;
      //that.idVerifica = -1;
      //alert("sono qui");
      this.svuotaCache(this.tableData.length);

      var val = {};
      val.id = 0;
      this.impostaDatiModello(val);

      this.idVerifica = 0;
      this.bStoPopolando = false;
      //console.log("modello impostato");
    },

    /*updateSort: function(modalitaExpert) {
      var that = this;
      var sort = {};
      if (modalitaExpert)
        sort = {
          prop: "delta",
          order: "ascending"
        };
      else {
        sort = {
          prop: "priceIndex",
          order: "ascending"
        };
      }
      that.$refs.griglia.clearSort();
      that.$refs.griglia.sort(sort.prop, sort.order);
    },*/

    updateSelectionOutput: function() {
      var that = this;

      this.tableData = jsonHelper.getProperty(that.projects, that.path + ".selectionOutput");
      this.misureData = jsonHelper.getProperty(that.projects, that.path + ".misureOutput");
      this.resultData = jsonHelper.getProperty(that.projects, that.parentPath + ".results");
    },

    settaValoreDiretto(elemento, valore) {
      var el = this.parentPath + "." + elemento;
      this.$store.dispatch("changeProjectProperty", {
        path: el,
        value: valore
      });
    },

    settaValoreUM(elementoUM, valore) {
      this.$store.dispatch("changeProjectProperty", {
        path: elementoUM,
        value: valore
      });
    },

    settaValore(elemento, valore, input, output, bilancio) {
      var el = this.parentPath + "." + elemento;
      if (input) {
        this.settaValoreUM(el + ".input.refValue.value", valore);
        this.settaValoreUM(el + ".input.usrValue.value", valore);
      }
      if (output) {
        this.settaValoreUM(el + ".output.refValue.value", valore);
        this.settaValoreUM(el + ".output.usrValue.value", valore);
      }
      if (bilancio) {
        this.settaValoreUM(el + ".output.outputBilancio.value", valore);
        this.settaValoreUM(el + ".output.outputBilancio.value", valore);
      }
    },
    impostaDatiModello(val) {
      var that = this;
      //this.$store.dispatch("impostaDatiModelloDaSelezione", val);
      //alert(val.id);
      //console.log(val);
      if (this.resultData) {
        //console.log(val.id + " < " + this.resultData.length);
        if (val.id < this.resultData.length) {
          //console.log("VAL");
          var selP = this.resultData[val.id];
          //console.log(selP);
          if (selP) {
            //var that = this;
            var pts = {};
            that.idLoad = val.id;
            that.idVerifica = -1;

            pts.project = that.GetCloneProject(); // clone senza le griglie dei risultati
            pts.scambiatore = selP;
            pts.index = val.id;

            // P = riferimento -> intero progetto
            //var P = that.cloneProject();
            var P = that.projects[that.parentPath];

            // CACHE
            var i = that.idLoad;

            //alert("i = " + i);
            //alert("that.cacheData[i] = " + that.cacheData[i]);

            if (that.cacheData[i] != null) {
              //alert("progetto presente in cache");

              let prj = that.cacheData[i];

              that.aggiornaProgetto(prj, P, selP);
            } else {
              if (pts != null) {
                that.impostaScambSelezionato(pts).then(data => {
                  //console.log(that.tableData[val.id].idGeometriaPiastra);
                  data.shoulder.geometry.id = that.tableData[val.id].idGeometriaPiastra;

                  //alert("chiamata al server");

                  /*
                if (data != null && data != undefined) {
                  data.selectionOutput.selectionOutput = P.selectionOutput.selectionOutput;
                  data.results = P.results;
                  data.innerProject = selP;

                  this.$store.dispatch("loadProject", {
                    projectId: data.projectId,
                    project: data
                  });

                  if (data.calculated) {
                    that.idVerifica = that.idLoad;
                    this.$store.dispatch("refreshAll");

                  }
                }
                that.idLoad = -1;
                */

                  // aggiorna cache
                  //that.cacheData[i] = data;
                  //alert("data = " + data);
                  that.cacheData[i] = JSON.parse(JSON.stringify(data));
                  //alert("that.cacheData[i] = " + that.cacheData[i]);

                  // aggiorna maschera risultati progetto
                  that.aggiornaProgetto(data, P, selP);
                });
              }
            }
          }
        }
      }
    },
    svuotaCache(count) {
      var that = this;

      that.cacheData = [];
      for (var i = 1; i <= count; i++) {
        that.cacheData.push(null);
      }
    },
    aggiornaProgetto(data, P, selP) {
      var that = this;
      if (data != null && data != undefined) {
        //data.selectionOutput.selectionOutput = P.selectionOutput.selectionOutput;
        //data.results = P.results;
        //data.innerProject = selP;

        //that.saveCalculatedProject(data);

        var prjData = {};
        if (selP.percentualeAltaResa > 0) {
          data.bottom.highPerformancePlatePercentageValue = selP.percentualeAltaResa;
        }
        data.bottom.numberOfPlates.input.usrValue.value = selP.numeroPiastre;
        data.bottom.numberOfPlates.input.refValue.value = selP.numeroPiastre;

        prjData.projectId = data.projectId;
        prjData.project = data;

        // console.log({ id: that.idLoad, projectData: prjData });
        //console.log(data);
        that.load(prjData).then(function() {
          if (data.calculated) {
            if (that.idLoad >= 0) {
              that.idVerifica = that.idLoad;
              that.idLoad = -1;
            }
          }
        });
      } else {
        that.idLoad = -1;
      }
    },
    /*saveCalculatedProject(project) {
      var that = this;

      projectService.saveCalculatedProject(project).then(function(data) {
        if (data != null && data != undefined) {
          that.$store.dispatch("loadProject", {
            projectId: data.projectId,
            project: data
          });

          if (data.calculated) {
            that.idVerifica = that.idLoad;
            that.$store.dispatch("refreshAll");
          }
        } else {
          alert(JSON.stringify(data));
        }
      });
    },*/
    GetCloneProject() {
      var P = this.projects[this.parentPath];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      //deepClone_P.innerProject = null;
      //deepClone_P.selectionOutput.selectionOutput = [];
      //deepClone_P.results = [];
      return deepClone_P;
    },
    cloneProject() {
      var P = this.projects[this.parentPath];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      return deepClone_P;
    },
    dblClick(val) {
      //alert("dblClick");
      //console.log(val);
      this.dblClickRow = val;
      //console.log(val);
      //this.impostaDatiModello(val);
      this.$emit("passaInVerifica");
    },

    handleCurrentChange(val) {
      //alert("handleCurrentChange");
      if (val && this.bStoPopolando == false) {
        this.currentRow = val;
        this.impostaDatiModello(val);
        //this.$emit("settaModello", val);
      }
    }
  }
};

/*

mySort: function() {
      let sort = {};
      if (this.modalitaExpert)
        sort = {
          prop: "delta",
          order: "ascending"
        };
      else {
        sort = {
          prop: "priceIndex",
          order: "ascending"
        };
      }
      console.log("ciccio > " + sort.prop);
      return sort;
    }

    */
</script>
